import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import "./HaqtInput.scss";

const HaqtInput = (props) => {
  const { id, name, placeholder, helperText } = props;

  // State to manage the value of the input
  const [value, setValue] = useState(props.value || ""); // Initial value from props or empty string

  const handleChange = (event) => {
    // Update the state with the new value
    setValue(event.target.value);

    // Pass the value to the onChange prop if provided
    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <div className="haqt-input-container">
      <TextField
        fullWidth
        id={id}
        name={name}
        placeholder={placeholder}
        value={value} // Use the local state value
        onChange={handleChange} // Handle change event
        error={props.error} // Ensure error is passed as boolean
        helperText={helperText}
        InputProps={{
          endAdornment: props.icon,
        }}
        FormHelperTextProps={{
          style: {
            textAlign: "center",
          },
        }}
        {...props}
      />
    </div>
  );
};

export default HaqtInput;

HaqtInput.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  error: PropTypes.any, // Ensure error prop is boolean
  helperText: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  icon: PropTypes.any,
};
